<template>
<div class="chapter">
<div class="inner_page">
<div id="TOC">
<h1>Table of Contents</h1>
<p class="noindentfirst"><a href="#/001cover">Cover Page</a></p>
<p class="noindent"><a href="#/002titlepage">Title Page</a></p>
<p class="noindent"><a href="#/004dedication">Dedication</a></p>
<p class="noindent"><a href="#/005epigraph">Epigraph</a></p>
<p class="noindent" id="parti"><a href="#/006part1">PART I: HOW TO HAVE AN ORIGIN WITHOUT A PLANET BLOWING UP, PARENTS MURDERED, RADIOACTIVE SPIDER BITES, COSMIC RAYS, GAMMA RAYS, WHITE DWARF STARS, ALIENS CRASH-LANDING, A MAGIC WORD, A MAGIC HAMMER, OR A SUPER SERUM</a></p>
<blockquote>
<p class="noindent" id="chapterone"><a href="#/007chapter1">CHAPTER ONE</a></p>
<p class="noindent" id="chaptertwo"><a href="#/008chapter2">CHAPTER TWO</a></p>
<p class="noindent" id="chapterthree"><a href="#/009chapter3">CHAPTER THREE</a></p>
<p class="noindent" id="chapterfour"><span href="#/010chapter4" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="noindent" id="chapterfive"><span href="#/011chapter5" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="noindent" id="chaptersix"><span href="#/012chapter6" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="noindent" id="chapterseven"><span href="#/013chapter7" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="noindent" id="chaptereight"><span href="#/014chapter8" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="noindent" id="chapternine"><span href="#/015chapter9" title="Link target outside of Sample">CHAPTER NINE</span></p>
</blockquote>
<p class="noindent" id="partii"><span href="#/016part2" title="Link target outside of Sample">PART II: “YOU STILL READ COMIC BOOKS AT YOUR AGE?!”</span></p>
<blockquote>
<p class="noindent" id="chapterten"><span href="#/017chapter10" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="noindent" id="chaptereleven"><span href="#/018chapter11" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="noindent" id="chaptertwelve"><span href="#/019chapter12" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="noindent" id="chapterthirteen"><span href="#/020chapter13" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
</blockquote>
<p class="noindent" id="partiii"><span href="#/021part3" title="Link target outside of Sample">PART III: BLOOMINGTON TO HOLLYWOOD: HOW TO GET THERE FROM HERE!</span></p>
<blockquote>
<p class="noindent" id="chapterfourteen"><span href="#/022chapter14" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="noindent" id="chapterfifteen"><span href="#/023chapter15" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p>
<p class="noindent" id="chaptersixteen"><span href="#/024chapter16" title="Link target outside of Sample">CHAPTER SIXTEEN</span></p>
<p class="noindent" id="chapterseventeen"><span href="#/025chapter17" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></p>
</blockquote>
<p class="noindent" id="partiv"><span href="#/026part4" title="Link target outside of Sample">PART IV: AT LONG LAST, THE DARK KNIGHT RETURNS!</span></p>
<blockquote>
<p class="noindent" id="chaptereighteen"><span href="#/027chapter18" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></p>
<p class="noindent" id="chapternineteen"><span href="#/028chapter19" title="Link target outside of Sample">CHAPTER NINETEEN</span></p>
<p class="noindent" id="chaptertwenty"><span href="#/029chapter20" title="Link target outside of Sample">CHAPTER TWENTY</span></p>
<p class="noindent" id="chaptertwenty-one"><span href="#/030chapter21" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></p>
</blockquote>
<p class="noindent" id="partv"><span href="#/031part5" title="Link target outside of Sample">PART V: “BATS” OF LUCK</span></p>
<blockquote>
<p class="noindent" id="chaptertwenty-two"><span href="#/032chapter22" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></p>
</blockquote>
<p class="noindent" id="epilogue2"><span href="#/033epilogue" title="Link target outside of Sample">EPILOGUE The Road Taken, the Road Not Taken</span></p>
<p class="noindent" id="acknowledgments"><span href="#/034acknowledgments" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="noindent" id="imagecredits"><span href="#/035imagecredits" title="Link target outside of Sample">IMAGE CREDITS</span></p>
<p class="noindent"><span href="#/036poem" title="Link target outside of Sample">Poem</span></p>
<p class="noindent" id="copyright"><span href="#/037copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003toc.vue?19980a94